import { Texture2D } from "./Texture2D";
import { BaseTexture } from "./BaseTexture";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { Color } from "../maths/Color";
import { LayaGL } from "../layagl/LayaGL";
import { NotImplementedError } from "../utils/Error";
export class RenderTexture2D extends BaseTexture {
    static get currentActive() {
        return RenderTexture2D._currentActive;
    }
    get depthStencilFormat() {
        return this._depthStencilFormat;
    }
    get defaultTexture() {
        return Texture2D.grayTexture;
    }
    getIsReady() {
        return true;
    }
    getColorFormat() {
        return this._colorFormat;
    }
    get sourceWidth() {
        return this._width;
    }
    get sourceHeight() {
        return this._height;
    }
    get offsetX() {
        return 0;
    }
    get offsetY() {
        return 0;
    }
    constructor(width, height, format = RenderTargetFormat.R8G8B8, depthStencilFormat = RenderTargetFormat.None) {
        super(width, height, format);
        this._mgrKey = 0;
        this._invertY = false;
        this._colorFormat = format;
        this._depthStencilFormat = depthStencilFormat;
        if (width != 0 && height != 0) {
            this._create();
        }
        this.lock = true;
    }
    get isCube() {
        return this._renderTarget._isCube;
    }
    get samples() {
        return this._renderTarget._samples;
    }
    get generateMipmap() {
        return this._renderTarget._generateMipmap;
    }
    _start() {
        throw new NotImplementedError();
    }
    _end() {
        throw new NotImplementedError();
    }
    _create() {
        this._renderTarget = LayaGL.textureContext.createRenderTargetInternal(this.width, this.height, this._colorFormat, this.depthStencilFormat, false, false, 1);
        this._texture = this._renderTarget._textures[0];
        this._texture.gammaCorrection = 2.2;
    }
    clear(r = 0.0, g = 0.0, b = 0.0, a = 1.0) {
        RenderTexture2D._clearColor.r = r;
        RenderTexture2D._clearColor.g = g;
        RenderTexture2D._clearColor.b = b;
        RenderTexture2D._clearColor.a = a;
        RenderTexture2D._clear = true;
    }
    getData(x, y, width, height) {
        const pixelCount = width * height * 4;
        let pixelArray;
        switch (this._renderTarget.colorFormat) {
            case RenderTargetFormat.R8G8B8:
            case RenderTargetFormat.R8G8B8A8:
                pixelArray = new Uint8Array(pixelCount);
                break;
            case RenderTargetFormat.R16G16B16A16:
                pixelArray = new Float32Array(pixelCount);
                break;
            default:
                throw "this function is not surpprt " + this._renderTarget.colorFormat.toString() + "format Material";
        }
        LayaGL.textureContext.readRenderTargetPixelData(this._renderTarget, x, y, width, height, pixelArray);
        return pixelArray;
    }
    getDataAsync(xOffset, yOffset, width, height, out) {
        return LayaGL.textureContext.readRenderTargetPixelDataAsync(this._renderTarget, xOffset, yOffset, width, height, out);
    }
    recycle() {
    }
    _disposeResource() {
        this._renderTarget && this._renderTarget.dispose();
    }
}
RenderTexture2D._clearColor = new Color(0, 0, 0, 0);
RenderTexture2D._clear = false;
RenderTexture2D._clearLinearColor = new Color();
RenderTexture2D.defuv = [0, 0, 1, 0, 1, 1, 0, 1];
RenderTexture2D.flipyuv = [0, 1, 1, 1, 1, 0, 0, 0];
